export type ChestTier = 'wooden' | 'iron' | 'silver' | 'gold';

export const CHEST_NAMES: Record<ChestTier, string> = {
  wooden: 'Wooden Chest',
  iron:   'Iron Chest',
  silver: 'Silver Chest',
  gold:   'Gold Chest',
};

/** Map V-rank → chest tier (4 chests across 10 ranks). */
export function chestForVRank(vRank: string): ChestTier {
  switch (vRank) {
    case 'V0': case 'V1': case 'V2': return 'wooden';
    case 'V3': case 'V4':            return 'iron';
    case 'V5': case 'V6':            return 'silver';
    case 'V7': case 'V8': case 'V9': return 'gold';
    default:                         return 'wooden';
  }
}

/** Map package tier (item count) → chest tier. */
export function chestForPackageItems(items: number): ChestTier {
  if (items >= 3000) return 'gold';
  if (items >= 500)  return 'silver';
  if (items >= 100)  return 'iron';
  return 'wooden';
}
